import { render, staticRenderFns } from "./MomentMine.vue?vue&type=template&id=57a65102&scoped=true&"
import script from "./MomentMine.vue?vue&type=script&lang=js&"
export * from "./MomentMine.vue?vue&type=script&lang=js&"
import style0 from "./MomentMine.vue?vue&type=style&index=0&id=57a65102&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a65102",
  null
  
)

export default component.exports